export default __webpack_public_path__ + "static/media/Agricantus.1f71479d.jpg";